import { clientPhiApi } from './http';

export const decrypt = (orgId, hashes) => clientPhiApi(orgId).post('decrypt', hashes);
export const getReport = (orgId, token) => clientPhiApi(orgId, true).post('report', { token });
